import { useEffect, useState } from "react";
import { getKpiData } from "./api";
import apiCalls from "src/api/apiCalls";
import Loader from "src/components/loader.component";
import { Alert } from "react-bootstrap";
const KpiComponent = ({ module = "crypto",customClass }) => {
    const [data, setData] = useState(null);
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        handleInitialization()
    }, [module]);
    const handleInitialization = async () => {
        setLoading(true);
        setError(null);
        setData(null);
        try {
            const res = await getKpiData(module);
            if (res.ok) {
                setData(res.data);
            } else {
                setError(apiCalls.isErrorDispaly(res))
            }
        } catch (err) {
            setError(apiCalls.isErrorDispaly(err))
        } finally {
            setLoading(false)
        }
    }
    return <>
        {!loading && error && <Alert variant="danger">
            <p style={{ color: 'red', margin: 10 }}><span className="icon error-alert me-2"></span>{error}</p>
        </Alert>}
        {loading && <Loader />}
        {!loading && data &&
            <div className={`grid ${customClass} mb-5`}>
                {data?.map(kpi => kpi.type === "Common" && <div className="bg-light-cardBg border border-light-cardBorder bg-[url('src/assets/images/card-bg.png')] px-3 py-4 rounded-2xl analytics-card" key={kpi.name}>
                    <div className={`kpi-bg-${kpi.color} kpicard-style`}>
                        <p className="text-light-primaryColor text-base font-sans font-normal mb-0.5">{kpi?.name}</p>
                        <h3 className={`text-light-addonColor font-sans font-medium break-all ${kpi?.balance?.toLocaleString().length > 16 && 'text-[22px]' || "text-xl"}`}>
                            {kpi.isCount ? kpi?.balance?.toLocaleString() :
                                `$ ${kpi?.balance?.toLocaleString(undefined, {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                })}`}</h3>
                    </div>
                </div>)}
            </div>}
    </>

}

export default KpiComponent;